import { fromJS, Record } from 'immutable';
import {
  generateKeys,
  generateSchema,
} from '../../../../utils/helpers/model.helper';

export const CREDIT_CARD_SCHEMA = Object.freeze({
  LAST_FOUR: '',
  TOKEN: '',
  TYPE: '',
});
const RECORD = generateSchema(CREDIT_CARD_SCHEMA);
const KEYS: any = generateKeys(CREDIT_CARD_SCHEMA);

export class CreditCard extends Record(RECORD) {
  static KEYS: any = KEYS;

  constructor(props?: any) {
    super(props && props.toMap ? props.toMap() : fromJS(props || {}));
  }

  get lastFour(): string {
    return this.get(KEYS.LAST_FOUR);
  }

  get token(): string {
    return this.get(KEYS.TOKEN);
  }

  get type(): string {
    return this.get(KEYS.TYPE);
  }
}
